/**
 * Feature flags
 * Deprecated: This is the way to add feature flags to apps/unified-portal and will be removed with that app. Please also add your feature flag to the feature-flags.config.ts in the relevant feature or api
 */
const FEATURE_FLAGS = {
  ACTIVE_RESPONSE_TEST_ENV: undefined,
  ACTIVE_RESPONSE_GOOGLE_WORKSPACE_TENANT: undefined,
  ACTIVE_RESPONSE_AURORA_ENDPOINT: undefined,
  ACTIVE_RESPONSE_GENERIC_FIREWALL_EDL: undefined,
  ACTIVE_RESPONSE_TANIUM: undefined,
  ACTIVE_RESPONSE_MIMECAST_V2: undefined,

  THREAT_INTEL_SKU: true, // https://arcticwolf.atlassian.net/browse/PB-7436

  // AWN-303740
  ADS_ASSETS: true,
  ADS_FULL_MOCKED: undefined,
  ADS_ASSET_TAGS: undefined,

  // AWN-1022275
  ADS_RISK_ADDITIONS: true,
  ADS_GA_RELEASE: true,

  // AWN-173958
  AGENTS_MODULE_INSTALLATION: true,

  // S2CX-354
  DATA_EXPLORER_VISUALIZATION: true,

  // AWN-320841
  DETECTION_CATALOG_EXPORT: undefined,
  DETECTION_CATALOG_TEST_ENV_REQUIRES_VPN: undefined,
  // S2CX-15011
  DETECTION_TYPE_FILTER: true,

  // S2CX-17533
  DESTRUCTICONS_VIEW_TASKS: undefined,

  EVENT_LOG_EVENTS_SOURCE: undefined, // S2CX-2980

  // AWN-220282 - Add hyper-v awn1000
  HYPER_V_1000_DOWNLOAD: undefined,

  // AWN-990795 Add FF for vlc HA frontend
  LOG_COLLECTION_HA: true,

  // SSC-3373 - Provide access to Nutanix vScanner image
  NUTANIX_SCANNER_DOWNLOAD: undefined,

  // AWN-226899 - Check recent Scanner jobs for issues
  SCANNER_ERR_BANNER: undefined,

  // S2CX-4939 - Scanner Configure and Activate
  SCANNER_CONFIGURE_ACTIVATE: true,
  SCANNER_TABLE_DATAGRID: true,

  // AWN-167523 Risks in Unified Portal
  RISKS_IN_UP_M1: true,
  RISKS_IN_UP_WIP: undefined,
  RISK_IN_UP_LIVE_TEST_DATA: undefined,
  RISKS_IN_UP_M2: undefined,
  EVA_IN_UP_M1: undefined,

  // AWN-218319 Address Autofill Input -- Site Telemetry
  SITE_TELEMETRY_ADDRESS_AUTOFILL: true,

  // S2CX-6440 Create Custom Dashboard - Insights
  INSIGHTS_CREATE_CUSTOM_DASHBOARD: undefined,

  DATA_EXPLORER_IMPROVED_SEARCH: undefined,

  CUSTOM_ALERTS: true,

  // S2CX-8892 Data Explorer SKUs - 14, 30, 90
  DE_SKUS: true,
  DE_SKUS_OVERRIDE: undefined,

  // Cipher AI Bog
  CIPHER_CHATBOT: undefined,

  // Foxhound
  SSC_SELF_SERVICE_UPGRADE: undefined,
  SSC_SELF_SERVICE_UPGRADE_RBAC_BYPASS: undefined,

  SHOW_AGENT_SETTINGS_PAGE: true,
  AGENT_INTERNAL_CONFIG_V2: undefined,
  SHOW_AGENT_GROUPING: undefined,

  ZOOMIN: undefined,

  // LABS-471 Blocklist Downloads
  BLOCKLIST_DOWNLOAD: true,

  // PLAT-2627 Access Control Feature
  ACCESS_CONTROL: undefined,

  CYBER_RESILIENCE_ASSESSMENT: true,

  // S2CX-374: Allow customers to manager their escalation configs
  SELF_SERVE_ESCALATIONS: undefined,

  SCAN_SCHEDULES_TABLE_V2: undefined,

  // S2CX-3325: New Onboarding Experience in Unified Portal
  NEW_ONBOARDING_EXPERIENCE: undefined,
  // IRR-801: Create Incident Response Feature
  INCIDENT_RESPONSE: true,

  /** PLAT-5202: ADS Fenrir V2 changes
   *  -  S2CX-15851: Add columns for expandable row fields - Optional columns
   *  -  PLAT-7874: Migrating assets filters from custom component to Data Grid Filters
   * */
  ADS_FENRIR_V2: true,

  // S2CX-13915: Enable seamless sign on experience between Unified and Cylance portals
  // TODO S2CX-16683: Cleanup feature flag
  CYLANCE_CONSOLE_LINKS: true,

  // PLAT-868: Tag management feature
  TAG_MANAGEMENT: undefined,

  //LABS-2515: Threat Intel Feed feature in TIP
  THREAT_INTEL_FEED: undefined,

  // S2CX-16581: Unified Portal IA, cleanup after non IA is removed
  UNIFIED_PORTAL_IA: false,

  // S2CX-12830: xConf Single Pane of Glass
  SINGLE_PANE_OF_GLASS: undefined,

  // IRR-1813: CRA PDF export
  CYBER_RESILIENCE_ASSESSMENT_PDF_EXPORT: true,

  //IRR-335: CRA | Improve Essential 8 Data Presentation to Align with Framework
  ESSENTIAL_8_SCORE: true,

  // S2CX-18474: Edit Escalation Groups, cleanup after GA
  CUSTOM_ALERTS_POST_GA: undefined,

  //S2CX-18678: Update Badges on All Alert Configurations
  SCU_STATUS_ENHANCEMENTS: false,

  CLOUD_SCANNERS_CSPM: undefined,

  CLOUD_SCANNERS_CSPM_TEST_ENV: undefined,

  // PLAT-6808: Saved Entity Filters
  SAVED_ENTITY_FILTERS: undefined,
} as const;

export type FeatureFlagKey = keyof typeof FEATURE_FLAGS;
export type FeatureFlagsRecord = Record<FeatureFlagKey, boolean>;

export const KEYS = Object.keys(FEATURE_FLAGS).sort() as FeatureFlagKey[];

export const initFeatureFlags = (flags = FEATURE_FLAGS) => {
  Object.entries(flags).forEach(([flag, value]) => {
    if (value === undefined) return;

    if (value) {
      window.localStorage.setItem(flag, JSON.stringify(value));
    } else {
      window.localStorage.removeItem(flag);
    }
  });
};
